import { VenueAmenity, VenueEventCategory, VenueStatus } from "../../models/venues";

// =============================================
// Status options
// =============================================
export const venueStatusOptions: { name: string; value: VenueStatus }[] = [
  { name: "Activo", value: "ACTIVE" },
  { name: "En Alerta", value: "ALERT" },
  { name: "Suspendido", value: "SUSPENDED" },
  { name: "Desvinculado", value: "UNLINKED" },
];

// =============================================
// Event category options
// =============================================
export const venueEventCategoryOptions: { name: string; value: VenueEventCategory }[] = [
  { name: "Deportivo", value: "DEPORTIVO" },
  { name: "Social", value: "SOCIAL" },
  { name: "Otro", value: "OTRO" },
];

// =============================================
// Amenities options
// =============================================
export const venueAmenityOptions: { name: string; value: VenueAmenity }[] = [
  { name: "Wi-Fi", value: "WIFI" },
  { name: "Proyector / Pantalla", value: "PROJECTOR" },
  { name: "Sonido / Micrófonos", value: "SOUND" },
  { name: "Estacionamiento", value: "PARKING" },
  { name: "Accesibilidad (Rampas/Ascensor)", value: "ACCESSIBILITY" },
  { name: "Climatización", value: "CLIMATE" },
];

// =============================================
// Label helpers
// =============================================
export const getVenueStatusLabel = (status?: VenueStatus): string => {
  return venueStatusOptions.find((o) => o.value === status)?.name ?? status ?? "";
};

export const getVenueStatusSeverity = (
  status?: VenueStatus
): "success" | "warning" | "danger" | "info" | undefined => {
  switch (status) {
    case "ACTIVE":
      return "success";
    case "ALERT":
      return "warning";
    case "SUSPENDED":
      return "danger";
    case "UNLINKED":
      return "info";
    default:
      return undefined;
  }
};

export const getAmenityLabel = (value: VenueAmenity): string => {
  return venueAmenityOptions.find((o) => o.value === value)?.name ?? value;
};

export const getEventCategoryLabel = (value: VenueEventCategory): string => {
  return venueEventCategoryOptions.find((o) => o.value === value)?.name ?? value;
};
